export default __webpack_public_path__ + "static/media/anthem-website-logos_naacp.ff489e25.webp";